import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ProposalService } from 'src/app/services/proposal.service';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { PackageInfo } from 'src/app/models/packageinfo';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import { DatePipe } from '@angular/common';
import Helper from 'src/app/core/utility/helper';
import Calculator from 'src/app/core/utility/calculator';
import { ProposalEstimate } from 'src/app/models/proposal-estimate';
import { ProposalLocation } from '../../../models/internal/proposal-location';

@Component({
    selector: 'app-proposalsummary',
    templateUrl: './proposalsummary.component.html',
    styleUrls: ['./proposalsummary.component.scss'],
})
export class ProposalsummaryComponent implements OnInit {
    @Output() submitProposalClicked = new EventEmitter<number>();
    @Output() saveProposalClicked = new EventEmitter<number>();
    @Input() isUpdateMode: boolean;
    @Input() PrimaryLevel: any;
    @Input() SecondaryLevel: any;
    @Input() TertiaryLevel: any;
    @Input() PhysicalInspectionMode: boolean;
    // @Output() testDataClicked = new EventEmitter<number>();
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    proposalSummary: CreateProposalDTO = new CreateProposalDTO();
    packageTypeDescription: string = '';
    transportModeDescription: string = '';
    proposalManufacturingLocation: ProposalLocation = null;
    proposalSecondaryProcessingLocation: ProposalLocation = null;
    sourceTypes: string = '';
    packagingMaterialPrimaryDescription: string = '';
    packagingMaterialSecondaryDescription: string = '';
    packagingMaterialTertiaryDescription: string = '';
    packagingTemplatePrimaryDescription: string = '';
    packagingTemplateSecondaryDescription: string = '';
    packagingTemplateTertiaryDescription: string = '';
    packagingDunnageTypePrimaryDescription: string = '';
    packagingDunnageTypeSecondaryDescription: string = '';
    packagingDunnageTypeTertiaryDescription: string = '';
    highestTabIndex: number = 0;
    defaultPartNumbers: string;
    overridenPartNumbers: string;
    showTertiaryLevelSummary: boolean;
    estimateDiff: string[] = [];
    pipe = new DatePipe('en-US');
    packageLevelDesc = [
      "Primary",
      "Secondary",
      "Tertiary"
    ];
    constructor(private proposalService: ProposalService) {}

    ngOnInit() {

        this.proposalService.globalUOMOnLoad.subscribe(uom => {
            if (uom) {
            this.globalUOM = uom;
            }
        });

        this.proposalService.globalUOMOnUserToggle.subscribe(uom => {
            if (uom) {
            this.globalUOM = uom;
            }
        });

        this.proposalService.highestTabIndex.subscribe(
            index => (this.highestTabIndex = index)
        );
        this.proposalService.createProposalDTO.subscribe(prop => {
            this.proposalSummary = prop;
            this.RefreshProposalSummary();
        });
        this.proposalService.packageTypeDescription.subscribe(desc => {
            this.packageTypeDescription = desc;
        });
        this.proposalService.transportModeDescription.subscribe(desc => {
            this.transportModeDescription = desc;
        });
        this.proposalService.proposalManufacturingLocation.subscribe( loc => {
          this.proposalManufacturingLocation = loc;
        });
        this.proposalService.proposalSecondaryProcessingLocation.subscribe( loc => {
          this.proposalSecondaryProcessingLocation = loc;

        });
        this.proposalService.packagingMaterialPrimaryDescription.subscribe(
            desc => {
                this.packagingMaterialPrimaryDescription = desc;
            }
        );
        this.proposalService.packagingMaterialSecondaryDescription.subscribe(
            desc => {
                this.packagingMaterialSecondaryDescription = desc;
            }
        );
        this.proposalService.packagingMaterialTertiaryDescription.subscribe(
            desc => {
                this.packagingMaterialTertiaryDescription = desc;
            }
        );
        this.proposalService.packagingDunnageTypePrimaryDescription.subscribe(
            desc => {
                this.packagingDunnageTypePrimaryDescription = desc;
            }
        );
        this.proposalService.packagingDunnageTypeSecondaryDescription.subscribe(
            desc => {
                this.packagingDunnageTypeSecondaryDescription = desc;
            }
        );
        this.proposalService.packagingDunnageTypeTertiaryDescription.subscribe(
            desc => {
                this.packagingDunnageTypeTertiaryDescription = desc;
            }
        );
        this.proposalService.packagingTemplatePrimaryDescription.subscribe(
            desc => {
                this.packagingTemplatePrimaryDescription = desc;
            }
        );
        this.proposalService.packagingTemplateSecondaryDescription.subscribe(
            desc => {
                this.packagingTemplateSecondaryDescription = desc;
            }
        );
        this.proposalService.packagingTemplateTertiaryDescription.subscribe(
            desc => {
                this.packagingTemplateTertiaryDescription = desc;
                this.showTertiaryLevelSummary = desc && desc.length > 0;
            }
        );
    }

    submitProposal() {
        this.submitProposalClicked.emit();
    }

    SaveProposal() {
        this.saveProposalClicked.emit();
    }

    // fillTestData() {
    //     this.testDataClicked.emit();
    // }

    RefreshProposalSummary() {
        this.defaultPartNumbers = this.getDefaultPartNumbers();
        this.overridenPartNumbers = this.getOverridenPartNumbers();
        this.sourceTypes = this.setSourceType();
    }

    setSourceType() {
        if (this.proposalSummary.DefaultProposal.PartInfo.Parts.length > 0 && this.proposalSummary.DefaultProposal.PartInfo.Parts[0]['ParentSourceTypeDescription']) {
            return Array.prototype.map
                    .call(this.proposalSummary.DefaultProposal.PartInfo.Parts, s => s['ParentSourceTypeDescription']).toString();
        } else if ( this.proposalSummary.DefaultProposal.PackageInfo.SourceTypes.length > 0 && this.proposalSummary.DefaultProposal.PackageInfo.SourceTypes[0]['SourceTypeDescription']) {
            return Array.prototype.map
            .call(this.proposalSummary.DefaultProposal.PackageInfo.SourceTypes, s => s['SourceTypeDescription'])
            .toString();
        } else {
            return Array.prototype.map
                    .call(this.proposalSummary.DefaultProposal.PartInfo.Parts, s => s['SourceTypeDescription'])
                    .toString();
        }
    }

    getDefaultPartNumbers() {
        if (!this.proposalSummary || !this.proposalSummary.DefaultProposal) {
            return '';
        }
        const defaultParts = this.proposalSummary.DefaultProposal.PartInfo.Parts;
        let notInToBeOverridden = defaultParts;
        if (
            this.proposalSummary.OverriddenProposal &&
            this.proposalSummary.OverriddenProposal.PartInfo &&
            this.proposalSummary.OverriddenProposal.PartInfo.Parts
        ) {
            const overridenParts = this.proposalSummary.OverriddenProposal
                .PartInfo.Parts;
            notInToBeOverridden = defaultParts.filter(
                item => overridenParts.indexOf(item) < 0
            );
        }
        return notInToBeOverridden
            ? Array.prototype.map
                  .call(notInToBeOverridden, s => s['PartNumber'])
                  .toString()
            : '';
    }

    getDimensionUOMName() {
        if (this.globalUOM) {
        return this.globalUOM.DimensionUoMName;
        } else {
            return '';
        }
    }
    getWeightUOMName() {
        if (this.globalUOM) {
        return this.globalUOM.WeightUoMName;
        } else {
            return '';
        }
    }

    getOverridenPartNumbers() {
        if (
            this.proposalSummary &&
            this.proposalSummary.OverriddenProposal &&
            this.proposalSummary.OverriddenProposal.PartInfo
        ) {
            const overridenParts = this.proposalSummary.OverriddenProposal
                .PartInfo.Parts;
            return overridenParts
                ? Array.prototype.map
                      .call(overridenParts, s => s['PartNumber'])
                      .toString()
                : '';
        } else {
            return '';
        }
    }

    getPartLength(defaultProposal: boolean = true) {
        const partInfo = this.getPartInfo();
        return partInfo && partInfo.Length ? partInfo.Length : '';
    }

    getPartWidth(defaultProposal: boolean = true) {
        const partInfo = this.getPartInfo();
        return partInfo && partInfo.Width ? partInfo.Width : '';
    }

    getPartHeight(defaultProposal: boolean = true) {
        const partInfo = this.getPartInfo();
        return partInfo && partInfo.Height ? partInfo.Height : '';
    }

    getPartWeight(defaultProposal: boolean = true) {
        const partInfo = this.getPartInfo();
        return partInfo && partInfo.Weight ? partInfo.Weight : '';
    }
    getPartUOM(defaultProposal: boolean = true) {
        const partInfo = this.getPartInfo();
        if (!partInfo || !partInfo.Parts || partInfo.Parts.length == 0) {
            return '';
        }
        return partInfo && partInfo.Parts[0].POUomCode ? partInfo.Parts[0].POUomCode : '';
    }
    getPackagingType() {
        if (this.packageTypeDescription) {
            return this.packageTypeDescription;
        }
        const packageInfo = this.getPackageInfo();
        return packageInfo && packageInfo.PackageTypeDescription
            ? packageInfo.PackageTypeDescription
            : '';
    }
    getTransportMode() {
        if (this.transportModeDescription) {
            return this.transportModeDescription;
        }
        const packageInfo = this.getPackageInfo();
        return packageInfo && packageInfo.TransportModeDescription
            ? packageInfo.TransportModeDescription
            : '';
    }
    getEffectivityDate() {
        const packageInfo = this.getPackageInfo();
        // if(packageInfo &&
        //     packageInfo.ProposalEffectivity &&
        //     packageInfo.ProposalEffectivity.EffectiveFrom)
        // {
        // const effectivityFrom = Helper.formatda this.pipe.transform(packageInfo.ProposalEffectivity.EffectiveFrom, 'short');
        // return effectivityFrom;
        // }
        // else
        // {
        //     return '';
        // }
            return Helper.formatDate(packageInfo.ProposalEffectivity.EffectiveFrom);
    }

    getFitForAirShipment() {
        const packageInfo = this.getPackageInfo();
        if (packageInfo) {
            return packageInfo.IsFitForAirShipment === true ? 'Yes' : 'No';
        } else {
            return '';
        }
    }

    getIsStackable() {
        const packageInfo = this.getPackageInfo();
        if (packageInfo) {
            return packageInfo.IsStackable === true ? 'Yes' : 'No';
        } else {
            return '';
        }
    }

    getManufacturingLocation() {
        const location = this.getProposalLocation(true, true);

        const location2 = Object.assign(new ProposalLocation(), location);

        if (location2) {
          return location2.toString();
        } else {
          return '';
        }
    }

    getSecondaryProcessingLocation() {
      const location = this.getProposalLocation(true, false);
      const location2 = Object.assign(new ProposalLocation(), location);
      if (location2) {
        return location2.toString();
      } else {
        return '';
      }
    }

    getProp(defaultProposal: boolean = true) {
        if (defaultProposal && this.proposalSummary) {
            return this.proposalSummary.DefaultProposal;
        } else if (this.proposalSummary) {
            return this.proposalSummary.OverriddenProposal;
        }
    }
    getTareWeight(level: number, defaultProposal: boolean = true) {
        const packageLevel = this.getPackageLevel(level - 1);
        return packageLevel ? packageLevel.TareWeight : '';
    }
    getQPC(level: number, defaultProposal: boolean = true) {
        const packageLevel = this.getPackageLevel(level - 1);
        return packageLevel ? packageLevel.QPC : '';
    }

    getDunnageType(level: number, defaultProposal: boolean = true) {
        const packageLevel = this.getPackageLevel(level - 1);
        return packageLevel ? packageLevel.DunnageType : '';
    }
    getNoOfContainers(level: number, defaultProposal: boolean = true) {
        const packageLevel = this.getPackageLevel(level - 1);
        return packageLevel ? packageLevel.ContainersPerLayer : '';
    }
    getNoOfLayers(level: number, defaultProposal: boolean = true) {
        const packageLevel = this.getPackageLevel(level - 1);
        return packageLevel ? packageLevel.NoOfLayers : '';
    }
    levelExists(level: number) {
        const packageLevel = this.getPackageLevel(level - 1);
        // return true if already the record has teh level
        if (packageLevel && packageLevel.PackageMaterialId > 0) {
            return true;
        }
        let formvalue: any;
        // check if user has done some input for the level, after page rendered;
        switch (level) {
            case 1: {
                formvalue = this.PrimaryLevel ? this.PrimaryLevel.value :  null;
                break;
            }
            case 2: {
                formvalue = this.SecondaryLevel ? this.SecondaryLevel.value : null;
                break;
            }
            case 3: {
                formvalue = this.TertiaryLevel ? this.TertiaryLevel.value : null;
                break;
            }
        }
        return (formvalue && formvalue.PackageMaterialId);
    }
    // setShowTertiaryLevelSummary() {
    //     let packageLevel = this.getPackageLevel(2);
    //     this.showTertiaryLevelSummary =
    //         packageLevel && packageLevel.PackagelevelTemplateId > 0;
    // }

    getPartInfo(defaultProposal: boolean = true) {
        const prop = this.getProp(defaultProposal);
        return prop ? prop.PartInfo : null;
    }

    getPackageInfo(defaultProposal: boolean = true) {
        const prop = this.getProp(defaultProposal);
        return prop ? prop.PackageInfo : null;
    }

    getProposalLocation(defaultProposal: boolean = true, isManufacturingLocation: boolean = true): ProposalLocation {
      const prop = this.getProp(defaultProposal);

      return prop ? isManufacturingLocation ? prop.ManufacturingLocation : prop.SecondaryProcessingLocation : null;
    }

    LevelClearClicked(level: number) {
        const prop = this.getProp();
        // prop.PackageInfo.ProposalPackageLevels[level - 1] = null;
    }
    getIsConditionalApproval() : boolean
    {
        const packageInfo = this.getPackageInfo();
        return packageInfo.IsConditionalApproval;
    }

    getPackageLevel(level: number, defaultProposal: boolean = true) {
        const packageInfo = this.getPackageInfo(defaultProposal);
        return packageInfo && packageInfo.ProposalPackageLevels
            ? packageInfo.ProposalPackageLevels[level]
            : null;
    }

    setpercentagePackageUtilization() {
        const primaryPackageLevel = this.proposalSummary.DefaultProposal.PackageInfo.ProposalPackageLevels[0];
        if (primaryPackageLevel) {
        const primaryQPC = Calculator.GetTotalPartQuantity_Primary(primaryPackageLevel.QPC);
        return Helper.getPercentagePackageUtilization(this.getPartInfo(), this.getPackageLevel(0), primaryQPC);
        } else {
            return null;
        }
    }

    getEstimateDiff() {
        if (this.isUpdateMode) return false;
        this.estimateDiff = [];
        this.proposalSummary.EstimateProposal.forEach(estimate => {
            this.getEstimatePackageLevelDiff(estimate.PackageLevelId as number, estimate);
        });

        return this.estimateDiff.length > 0;
    }
    getEstimatePartDiff(estimate: ProposalEstimate) {
        let levelName = "[Part]: ";
        const packageInfo = this.getPackageInfo();
        // if (this.getPartLength() != estimate.PartLength)
        //     this.estimateDiff.push(levelName + "Length")
        // if (this.getPartWidth() != estimate.PartWidth)
        //     this.estimateDiff.push(levelName + "Width")
        // if (this.getPartHeight() != estimate.PartHeight)
        //     this.estimateDiff.push(levelName + "Height")
        // if (this.getPartWeight() != estimate.PartWeight)
        //     this.estimateDiff.push(levelName + "Weight")

        if (packageInfo.PackageTypeId != estimate.PackageTypeId)
            this.estimateDiff.push(levelName + "Packaging Type")
        if (packageInfo.TransportModeId != estimate.TransportModeId)
            this.estimateDiff.push(levelName + "Transport Mode")

        // if (Helper.formatDate(packageInfo.ProposalEffectivity.EffectiveFrom) != Helper.formatDate(estimate.EffectiveFrom))
        //     this.estimateDiff.push(levelName + "Effective From Date")
    }

    getStackabilityDiff(estimate: ProposalEstimate) {
        let levelName = "[Part]: ";
        const packageInfo = this.getPackageInfo();

        if (estimate.PackageLevelId != this.proposalSummary.EstimateProposal.length) return;

        if (packageInfo.IsStackable != estimate.IsStackable)
            this.estimateDiff.push(levelName + "Stackability")
        if (estimate.IsStackable) {
            if (packageInfo.NoOfStackableUnitsForShipping != estimate.NoOfStackableUnitsForShipping)
                this.estimateDiff.push(
                    levelName + 'Stack Height for Shipping (# Unit loads)'
                );
            if (packageInfo.NoOfStackableUnitsForWarehousing != estimate.NoOfStackableUnitsForWarehousing)
                this.estimateDiff.push(
                    levelName + 'Stack Height for Warehousing (# Unit loads)'
                );
        }
    }

    getPackagingLevelDetails(level: number) {
        switch (level) {
            case 1: {
                return [this.packagingTemplatePrimaryDescription, this.packagingMaterialPrimaryDescription, this.packagingDunnageTypePrimaryDescription];
            }
            case 2: {
                return [this.packagingTemplateSecondaryDescription, this.packagingMaterialSecondaryDescription, this.packagingDunnageTypeSecondaryDescription];
            }
            case 3: {
                return [this.packagingTemplateTertiaryDescription, this.packagingMaterialTertiaryDescription, this.packagingDunnageTypeTertiaryDescription];
            }
        }
    }

    getEstimatePackageLevelDiff(level: number, estimate: ProposalEstimate) {
        let levelName = `[${this.packageLevelDesc[level - 1]}]: `;
        let packageLevel = this.getPackageLevel(level - 1);
        if (packageLevel == null) return;
        let [packageEquipmentCode, packagingMaterial, packagingDunnage] = this.getPackagingLevelDetails(level);

        if(level == 1) this.getEstimatePartDiff(estimate);

        this.getStackabilityDiff(estimate);
        if (estimate.TeslaPackageEquipmentCode && estimate.TeslaPackageEquipmentCode.length !== 0) {
            if (packageEquipmentCode != estimate.TeslaPackageEquipmentCode)
                this.estimateDiff.push(levelName + "Tesla Package Code")
        } else {
            if (Number(packageLevel.Length.toFixed(2)) !== Number(estimate.PackageLength.toFixed(2)))
                this.estimateDiff.push(levelName + "Package Length")
            if (Number(packageLevel.Width.toFixed(2)) !== Number(estimate.PackageWidth.toFixed(2)))
                this.estimateDiff.push(levelName + "Package Width")
            if (Number(packageLevel.Height.toFixed(2)) !== Number(estimate.PackageHeight.toFixed(2)))
                this.estimateDiff.push(levelName + "Package Height")
        }


        if (Number(packageLevel.TareWeight.toFixed(2)) !== Number(estimate.TareWeight.toFixed(2)))
            this.estimateDiff.push(levelName + "Tare Weight")

        if (this.getQPC(level) != estimate.QPC)
            this.estimateDiff.push(levelName + "QPC")

        if (packagingMaterial != estimate.PackageMaterialName)
            this.estimateDiff.push(levelName + "Packaging Material")

        // if (!packagingDunnage.includes(estimate.DunnageTypeDescription))
        //     this.estimateDiff.push(levelName + "Packaging Dunnage")

        // if (level > 1) {
        //     if (this.getNoOfContainers(level) != estimate.ContainersPerLayer)
        //         this.estimateDiff.push(levelName + "No Of Containers Per Layer")
        //     if (this.getNoOfLayers(level) != estimate.NoOfLayers)
        //         this.estimateDiff.push(levelName + "No Of Layers")
        // }

    }

}
